import React from "react";
import "./HotelMobileFilters.css";
import { Col, Container, Row } from "react-bootstrap";
import { FaFilter } from "react-icons/fa";
import { FaCity } from "react-icons/fa6";


import { MdBreakfastDining, MdSort } from "react-icons/md";
import { MdToggleOff } from "react-icons/md";
// import { div } from "react-router-dom";
import { IoIosStar } from "react-icons/io";
import { RiMoneyRupeeCircleFill } from "react-icons/ri";

function HotelMobileFilters({toggleFilter}) {
  return (
    <div className="Hotel-menuContainerMain" style={{ position: "relative" }}>
      <div className="Hotel-menuContainer">
        <div onClick={() => toggleFilter("filter")}>
          <div className="hotelFilter-menuItem">
            <FaFilter className="hotel-menuIcons" />
            Filter
          </div>
        </div>
        <div onClick={() => toggleFilter("rating")}>
          {" "}
          <div className="hotelFilter-menuItem">
            <IoIosStar className="hotel-menuIcons" />
            Rating
          </div>
        </div>
        <div onClick={() => toggleFilter("price")}>
          {" "}
          <div className="hotelFilter-menuItem">
            <RiMoneyRupeeCircleFill className="hotel-menuIcons" />
            Price
          </div>
        </div>
        <div onClick={() => toggleFilter("facility")}>
          {" "}
          <div className="hotelFilter-menuItem">
            {" "}
            <FaCity className="hotel-menuIcons" /> Facilities
          </div>
        </div>
        <div onClick={() => toggleFilter("sort")}>
          <div className="hotelFilter-menuItem">
            <MdSort className="hotel-menuIcons" />
            Sort
          </div>
        </div>
      </div>
    </div>
  );
}

export default HotelMobileFilters;
